import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { LotteryOpenService } from './../../../services/lotteryopen.service';
import { LotteryOpenModel } from './../../../models/lotteryopen.model';
import { LoaddingService } from './../../../providers/loadding.service';
import { PageDefault } from './../../../pages/PageDefault';
import { BettingOrderPage } from './../../../pages/bettingorder/bettingorder';
import { Content } from 'ionic-angular';
import { AppConfig } from './../../../app/app.config';
import { StorageService } from './../../../providers/storage.service';
import { BettingParamService } from './../../../services/betting.param.service';
import { LotteryService } from './../../../services/lottery.service';
import { BettingOrderHelper } from './../../bettingorder/bettingorder.helper';
import { LotteryModel } from '../../../models/lottery.model';
import { BrickTrendPage } from '../brick-trend/brick-trend';

/*
    指定彩种的开奖号码列表信息
    TQQ 2016-12-27
*/

@Component({
    selector: 'open-list',
    templateUrl: 'openlist.html',
    providers: [LotteryOpenService, LotteryService, BettingOrderHelper]
})

export class OpenList {
    constructor(
        private navParam: NavParams,
        private lotteryopenService: LotteryOpenService,
        private loadding: LoaddingService,
        private viewCtrl: ViewController,
        private config: AppConfig,
        private storage: StorageService,
        public navCtrl: NavController,
        private lotteryService: LotteryService,
        private bettingHelper: BettingOrderHelper
    ) { }


    lastIssueNo = "";//最新期号
    lastOpenNo = "";//最新开奖号码
    lotteryCode = "";
    lotteryName = "";
    currPage = 1;
    openList: LotteryOpenModel[];

    @ViewChild(Content) content: Content;

    toggleToolbar() {
        this.content.resize();
    }

    ionViewDidLoad() {
        this.lotteryCode = this.navParam.get("lotteryCode");
        this.lotteryName = this.navParam.get("lotteryName");
        let load = this.loadding.showLoding();
        this.getLotteryOpen(this.lotteryCode).then(s => {
            this.loadding.closeLoading(load);
        });
    }

    //下拉重新加载
    //TQQ 2016-12-27
    doRefresh(refresher) {
        this.getLotteryOpen(this.lotteryCode).then(s => {
            refresher.complete();
        });
    }


    //上拉获取下一页信息
    //TQQ 2016-12-27
    doInfinite(infiniteScroll) {
        this.currPage++;
        this.getLotteryOpen(this.lotteryCode, this.currPage).then(s => {
            infiniteScroll.complete();
        });
    }


    //获取彩种的开奖号码
    //TQQ 2016-12-27
    getLotteryOpen(lotteryCode: string, pageIndex: number = PageDefault.PageIndex(), pageSize: number = PageDefault.PageSize()) {
        return this.lotteryopenService.getLotteryOpen(lotteryCode, pageIndex, pageSize)
            .then(s => {
                if (pageIndex == 1) {
                    this.openList = [];
                    this.openList = s;
                } else {
                    this.openList = this.openList.concat(s);
                }
                if (this.openList.length > 0) {
                    this.lastIssueNo = this.openList[0].IssueNo;
                    this.lastOpenNo = this.openList[0].LotteryOpenNo;
                }
                this.normalizeCanada28();
                return this.decorateMarkSix();
            });
    }

    normalizeCanada28() {
        if (this.lotteryCode != "50001") {
            return;
        }
        this.openList.forEach((item) => {
            let numbers = item.LotteryOpenNo.split(",");
            if (numbers.length == 3) {
                item.sumOpenNum = numbers.reduce((sum, value) => sum + Number(value), 0);
                item.LotteryOpenNo += "," + item.sumOpenNum;
            }
        });
    }

    decorateMarkSix() {
        if (this.lotteryCode != "95000") {
            return Promise.resolve();
        }
        let cachedSettings = this.storage.read<any>("markSixInfo");
        if (cachedSettings) {
            this.applyMarkSixSettings(cachedSettings);
            return Promise.resolve();
        }
        return this.lotteryService.getSixSetting().then((settings) => {
            if (settings) {
                this.storage.write("markSixInfo", settings);
                this.applyMarkSixSettings(settings);
            }
        }).catch(() => Promise.resolve());
    }

    applyMarkSixSettings(settings) {
        let configuredYear = Number(settings.LiuhecaiHXDate);
        AppConfig.markSixYear = configuredYear > 1900 ? configuredYear : new Date().getFullYear();
        AppConfig.markSixPrevYear = AppConfig.markSixYear - 1;
        let issues = settings.LotteryIssues || [];
        let issueSetting = issues.find((item) => item.LotteryCode == this.lotteryCode);
        AppConfig.markSixStartIssue = issueSetting ? issueSetting.StartIssue : "";

        this.openList.forEach((open) => {
            let zodiacYear = AppConfig.markSixYear;
            if (AppConfig.markSixStartIssue
                && Number(open.IssueNo) < Number(AppConfig.markSixStartIssue)) {
                zodiacYear = AppConfig.markSixPrevYear;
            }
            open.openNumList = open.LotteryOpenNo.split(",").map((value) => {
                let zodiac = this.bettingHelper.getZodiacAndPoultryByYean(
                    zodiacYear - (Number(value) - 1)
                );
                return {
                    figures: value,
                    color: this.bettingHelper.getLetteryMarkSixColor(value).color,
                    zodiac: zodiac.zodiac,
                    isPoultry: zodiac.isPoultry
                };
            });
        });
    }

    //页面返回
    //chen 2017-01-19
    close() {
        this.viewCtrl.dismiss();
    }

    //前往投注
    //chen 2017-02-14
    goBetting() {
        BettingParamService.applyPlayModeBeforeNavigate(this.lotteryCode, this.storage);
        // this.navCtrl.push(BettingOrderPage,{
        //     lotteryCode:this.lotteryCode
        // });
        this.config.NavCtrl.push(BettingOrderPage, {
            lotteryCode: this.lotteryCode
        });
    }
    goTrend(obj) {
        let bricks: any = this.storage.read<LotteryModel[]>("lotterys");
        let brick = bricks.find((item) => {
            return obj.LotteryCode == item.LotteryCode;
        });
        this.navCtrl.push(BrickTrendPage, { brick: brick });
    }
}


// WEBPACK FOOTER //
// ./src/pages/lotteryopen/list/openlist.ts